import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AppDispatch, RootState } from "./store/store";
import { getUserProfile } from "./store/slice/authThunks";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Login from "./pages/Login";
import PhoneLogin from "./pages/PhoneLogin";
import Register from "./pages/Register";
import Services from "./pages/Services";
import ProviderProfile from "./pages/ProviderProfile";
import PostJob from "./pages/PostJob";
import CustomerDashboard from "./pages/Dashboard/CustomerDashboard";
import About from "./pages/About";
import PrivateRoute from "./routes/PrivateRoute";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import WorkmanNaijaDashboard from "./pages/Dashboard/WorkmanNaijaDashboard";
import AdminDashboard from "./pages/Dashboard/AdminDashboard";
import UserSignUp from "./pages/UserSignUp";
import ForgotPassword from "./pages/ForgotPassword";
import HowItWorks from "./pages/HowItWorks";
import LocationSearch from "./pages/LocationSearch";
import ProviderResults from "./components/ProviderResults";
import PaymentCallback from "./pages/PaymentCallback";
import ProviderRegistration from "./pages/ProviderRegistration";
import FAQ from "./pages/FAQ";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import DownloadApp from "./pages/DownloadApp";

const App: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { token, user } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    if (token && !user) {
      dispatch(getUserProfile());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/login-phone" element={<PhoneLogin />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgotPassword" element={<ForgotPassword />} />
          <Route path="/services" element={<Services />} />
          <Route path="/userSignUp" element={<UserSignUp />} />
          <Route path="/provider/:id" element={<ProviderProfile />} />
          <Route path="/post-job" element={<PostJob />} />
          <Route
            path="/search"
            element={
              <>
                <LocationSearch />
                <div className="max-w-7xl mx-auto px-4 pb-12">
                  <ProviderResults />
                </div>
              </>
            }
          />
          <Route path="/register-provider" element={<ProviderRegistration />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/download-app" element={<DownloadApp />} />
          <Route path="/payments/callback" element={<PaymentCallback />} />
          <Route
            path="/dashboard/customer"
            element={
              <PrivateRoute role="ROLE_USER">
                <CustomerDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/handyman"
            element={
              <PrivateRoute role="ROLE_WORKMAN">
                <WorkmanNaijaDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/admin"
            element={
              <PrivateRoute role="ROLE_ADMIN">
                <AdminDashboard />
              </PrivateRoute>
            }
          />
          <Route path="/about" element={<About />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </Router>
  );
};

export default App;
